import React from 'react'
import Head from 'next/head'
import isEmpty from 'lodash/isEmpty'
import {
  mapFiltersFromUrl,
  generateQueryString,
  convertFilters,
  removeNullValues,
} from '../../lib/filterFormatter'
import { cookieValuetoJSON } from '../../lib/objectValidation'
import { get, headers } from '../../lib/fetch'
import Router, { withRouter } from 'next/router'
import { PAGE_TYPES } from '../../lib/eventTrackerFunction'
import LayoutWithFilterAndSort from '../../components/LayoutWithFilterAndSort'
import { getActiveExperimentVariants } from '../../lib/getActiveExperimentVariants'
import { getLayoutByName } from '../../components/LoadLayout'
import { getIosSmartBannerContent } from '../../utils/getIosSmartBannerContent'
import { getUserType } from '../../utils/userType'
import { CTA_LOCATION_NAME } from '../../lib/amplitude'
import { setCtaLocationMeta } from '../../lib/utils'
import NdsThemeProvider from '@ntuctech/devex-tangram/Theme/NdsThemeProvider'
import { getConfigFor } from '../../utils/configService'
import getCanonicalUrl from '../../lib/getCanonicalUrl'
import { SPLIT_FEATURES } from '../../utils/constants'
import {
  initDyCookies,
  initDyParams,
  setDySessionFromLayout,
} from '../../utils/DyUtils'

const PRODUCT_LAYOUT_NAME = 'ProductCollection'

const getData = async (checkoutAddress, router, activeExperiments = '') => {
  const { query, res } = router || {}
  /* istanbul ignore next */
  typeof window === 'undefined' && res.startTime('initDy', 'initDy')
  const dyParams = initDyParams(router)
  /* istanbul ignore next */
  typeof window === 'undefined' && res.endTime('initDy')
  const API = `layout/promotion/v2`

  const basicQueryStringObject = {
    page: 1,
    pageType: 'promotion',
    storeId: checkoutAddress?.storeId || null,
    orderType: getUserType(router) === 'B2B' ? 'B2B' : 'DELIVERY',
    includeTagDetails: true,
  }
  if (activeExperiments.length) {
    const { configuration } = getConfigFor(
      SPLIT_FEATURES.ALGOLIA_PERSONALISATION
    )
    const { personalisationSettings } = configuration
    basicQueryStringObject.algopers = personalisationSettings
    basicQueryStringObject.experiments = activeExperiments
  }
  const queryStringObject = {
    ...basicQueryStringObject,
  }
  for (const key in query) {
    if (!['filter', 'tag', 'pageType'].includes(key)) {
      queryStringObject[key] = query[key]
    }
  }

  if (query?.filter || query?.tag) {
    let transferredFilter = mapFiltersFromUrl(query?.filter)
    if (query?.tag) {
      transferredFilter = { ...transferredFilter, tag: [query?.tag] }
    }
    queryStringObject.filter = convertFilters(transferredFilter)
  }

  if (query?.sorting) {
    queryStringObject.sorting = query.sorting
  }

  const request = API + generateQueryString(queryStringObject) + dyParams
  const response = await get(request, {
    headers: headers(router),
  })

  const mainCollection =
    getLayoutByName(
      response?.data?.page?.layouts,
      PRODUCT_LAYOUT_NAME,
      PAGE_TYPES.PROMO
    ) || {}
  /**
   * NOTE: Keep the multiple checks in if condition as they are
   * API failure can return value: null sometimes
   * If failing call was for ALL tag it will cause infinite calls to the API
   */
  if (
    mainCollection?.value &&
    mainCollection?.value?.collection &&
    mainCollection?.value?.collection?.count === 0 &&
    typeof window !== 'undefined'
  ) {
    let href = router?.pathname
    const asPath = router?.asPath?.split('?')[0]
    href += generateQueryString(basicQueryStringObject)
    Router.push(href, asPath)
  }
  return response
}
class Promotions extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      layouts: props.layouts || [],
      isStoreChanged: false,
    }
    this.setLocationMeta = this.setLocationMeta.bind(this)
  }

  setLocationMeta() {
    const { query } = this.props.router
    const ctaLocationMeta = query.tag || 'all'
    setCtaLocationMeta([ctaLocationMeta])
  }

  componentDidMount() {
    setDySessionFromLayout(this.props.layouts)
    this.setLocationMeta()
    initDyCookies()
  }

  componentWillUnmount() {
    setCtaLocationMeta([])
  }

  async componentDidUpdate(prevProps) {
    const { checkoutAddress, router } = this.props
    const activeExperiments = getActiveExperimentVariants()

    if (
      (prevProps.checkoutAddress &&
        String(prevProps.checkoutAddress.storeId) !==
          String(checkoutAddress.storeId)) ||
      prevProps.checkoutAddress.type !== checkoutAddress.type
    ) {
      const response = await getData(checkoutAddress, router, activeExperiments)
      const layouts = response?.data?.page?.layouts || []
      const mainCollection =
        getLayoutByName(layouts, PRODUCT_LAYOUT_NAME, PAGE_TYPES.PROMO) || {}
      this.setState({
        storeSpecificProduct: mainCollection?.value?.collection || {},
        layouts: layouts,
        isStoreChanged: true,
      })
      setDySessionFromLayout(layouts)
    }

    // check for query changes to use changed data from props instead of state
    const { query } = router
    this.setLocationMeta()
    if (
      prevProps.router?.query?.slug !== query?.slug ||
      prevProps.router?.query?.filter !== query?.filter ||
      prevProps.router?.query?.sorting !== query?.sorting ||
      prevProps.router?.query?.tag !== query?.tag
    ) {
      this.setState({
        storeSpecificProduct: this.props.data?.data || {},
        layouts: this.props.layouts || [],
        isStoreChanged: false,
      })
    }
  }

  render() {
    const {
      organizationData,
      categoryList,
      data,
      router,
      iosSmartBannerContent,
    } = this.props
    let title = ''
    if (router?.query?.tag === 'everyday-low-price') {
      title = 'Looking for Low Price Grocery? Shop FairPrice Now'
    } else if (router?.query?.tag === 'price-drop-buy-now') {
      title = 'Get Big Savings with FairPrice Price Drop Promotions'
    } else {
      title = 'Discover All Current Promotions & Deals at FairPrice SG'
    }
    const collection = this.state.isStoreChanged
      ? this.state.storeSpecificProduct
      : data.data
    let { filters } = collection || {}
    filters = removeNullValues(filters?.side) || {}
    const layouts = this.state.layouts || []
    const selectedTagObj = !isEmpty(filters?.tag?.find(tag => !!tag.checked))
      ? [filters?.tag?.find(tag => !!tag.checked)]
      : [{ name: 'All' }]
    const trackingCategoryName =
      selectedTagObj && selectedTagObj[0]
        ? selectedTagObj[0].name.replace(',', '').replace(/\s/g, '')
        : ''
    return (
      <React.Fragment>
        <Head>
          <title>{title}</title>
          <meta
            name="description"
            key="meta_description"
            content="Wide range of groceries at great deals! Save now on your favorite brands. Price match, online and in-store."
          />
          <meta property="og:type" content="website" />
          <meta property="og:title" content={title} />
          <meta property="og:site_name" content="FairPrice" />
          <meta name="apple-itunes-app" content={iosSmartBannerContent} />
          <link rel="canonical" href={getCanonicalUrl(router.asPath)} />
        </Head>
        <NdsThemeProvider>
          <LayoutWithFilterAndSort
            title="Promotions"
            layouts={layouts}
            organizationData={organizationData}
            categoryList={categoryList}
            preLoadFirstImage={true}
            ctaLocation={{
              pageName: CTA_LOCATION_NAME.PROMOTION,
              pageMeta: [this.props.router?.query?.tag || 'all'],
            }}
            config={{
              pageType: PAGE_TYPES.PROMO,
              url: this.props.router?.query?.tag,
              loc: `Offers-${trackingCategoryName}`,
            }}
            filterExcept={['tag', 'PWP', 'isEndlessAisle']}
          />
        </NdsThemeProvider>
      </React.Fragment>
    )
  }
}

Promotions.defaultProps = { data: {} }

Promotions.getInitialProps = async ctx => {
  const { res } = ctx
  /* istanbul ignore next */
  typeof window === 'undefined' &&
    res.startTime('beforepromoapi', 'before promo api')
  const user_type = getUserType(ctx)
  const iosSmartBannerContent = getIosSmartBannerContent(ctx)
  const checkoutAddress = cookieValuetoJSON(
    ctx,
    user_type === 'B2B' ? 'b2bCheckoutAddress' : 'checkoutAddress'
  )
  const activeExperiments = getActiveExperimentVariants(ctx) || ctx.experiments
  /* istanbul ignore next */
  typeof window === 'undefined' && res.endTime('beforepromoapi')
  typeof window === 'undefined' && res.startTime('promoapi', 'promo api')
  const response = await getData(checkoutAddress, ctx, activeExperiments)
  const layouts = response?.data?.page?.layouts || []
  const mainCollection =
    getLayoutByName(layouts, 'ProductCollection', PAGE_TYPES.PROMO) || {}
  const responseData = {
    data: { data: mainCollection?.value?.collection },
    layouts: layouts,
    iosSmartBannerContent,
  }
  /* istanbul ignore next */
  typeof window === 'undefined' && res.endTime('promoapi')
  return responseData
}

export default withRouter(Promotions)
